var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShowAppointments = function SvgShowAppointments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5324 11.9676H16.545C17.9106 11.9676 18.6481 12.4211 18.896 13.4598C19.1684 14.6008 18.6357 15.0689 17.4541 15.0689H16.2727L15.5324 11.9676Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4485 7H4.97712C4.10769 7 3.52726 7.68729 3.68069 8.53514L7.35562 23.4648C7.50905 24.3127 8.33824 25 9.20767 25H30.679C31.5484 25 32.1288 24.3127 31.9754 23.4648L28.3005 8.53514C28.147 7.68729 27.3179 7 26.4485 7ZM21.004 20.5547H23.5664L19.7791 16.1953C21.051 15.6102 21.5495 14.8056 21.2283 13.4598C20.7394 11.4118 19.0631 10.4316 16.2244 10.4316H12.9102L15.3266 20.5547H17.5822L16.6359 16.5903H17.7867L21.004 20.5547Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18711 8.7773L5.42819 21.9575H1.41959C0.517138 21.9575 -0.111061 21.3863 0.0164339 20.6818L2.18711 8.7773Z",
    fill: "currentColor"
  })));
};
export default SvgShowAppointments;